'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');let

EditDataRetentionPeriodModalController=(_dec=










































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class EditDataRetentionPeriodModalController extends BaseController{static get $inject(){return['$modalInstance','selectedRetentionPeriod','availableDataRetentionPeriods','socketService','uiCommandFactory','notificationService','onRetentionPeriodUpdated','uncaughtErrorHandler']}constructor($modalInstance,selectedRetentionPeriod,availableDataRetentionPeriods,socketService,uiCommandFactory,notificationService,onRetentionPeriodUpdated,uncaughtErrorHandler){super(uncaughtErrorHandler);this._socketService=socketService;this._$modalInstance=$modalInstance;this._onRetentionPeriodUpdated=onRetentionPeriodUpdated;this._notificationService=notificationService;this._updateRetentionPeriodCommand=uiCommandFactory.makeForModal($modalInstance,this._updateRetentionPeriod.bind(this));this.availableDataRetentionPeriods=availableDataRetentionPeriods;this.selectedRetentionPeriod=selectedRetentionPeriod}onCancel(){this._$modalInstance.dismiss()}get updateRetentionPeriodCommand(){return this._updateRetentionPeriodCommand}get submissionResult(){return this._submissionResult}
async _updateRetentionPeriod(){
const updateResult=await this._socketService.sendAndWaitForResponse('UpdateDataRetentionPeriod',
this.selectedRetentionPeriod);

this._submissionResult=updateResult;

if(!SocketResponse.succeeded(updateResult)){
if(this._submissionResult.status==='InvalidDataRetentionPeriod'){
this._notificationService.displayNotification('Invalid data retention period selected. Change has not been applied.','error');
}else{
this._notificationService.displayNotification('An unexpected error occurred, please try again later.','error');
return ModalSubmissionResult.KeepOpen;
}
}

this._onRetentionPeriodUpdated();

return ModalSubmissionResult.Close();
}},(_applyDecoratedDescriptor(_class.prototype,'_updateRetentionPeriod',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_updateRetentionPeriod'),_class.prototype)),_class));


module.exports=EditDataRetentionPeriodModalController;
//# sourceMappingURL=editDataRetentionPeriodModalController.js.map
